import { render, staticRenderFns } from "./SendLetterAccountStep.vue?vue&type=template&id=04d988b8&"
import script from "./SendLetterAccountStep.vue?vue&type=script&lang=js&"
export * from "./SendLetterAccountStep.vue?vue&type=script&lang=js&"
import style0 from "./SendLetterAccountStep.vue?vue&type=style&index=0&id=04d988b8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports